<template>
  <base-icon
      v-on="$listeners"
      v-bind="$attrs"
      :transform-function="(value) => typeof value === 'object' ? value.isDatevDownloaded : value"
      icon="mdi-file-download"
      :title="(value) => value ? 'settlement.titleIsDatevDownloaded' : 'settlement.titleIsNotDatevDownloaded'"
  />
</template>

<script>
import BaseIcon from '@/components/icons/BaseIcon';
export default {
  name: 'SettlementDatevDownloadedIcon',
  components: {BaseIcon},
}
</script>

<style scoped>

</style>